import Vue from 'vue'

const UTENTE_CRO = 18

export default {
    namespaced: true,
    state: {
        segnalazioni: [],
        statoSegnalazioni: null,
        segnalazioneMostrata: null,
        centroMappa: null
    },
    getters: {
        segnalazioniFiltrate: (state: any, getters: any, rootState: any) => (
            state.segnalazioni
                .filter((segnalazione: any) => (
                    (!rootState.reportFiltriSegnalazione.idSegnalazione || rootState.reportFiltriSegnalazione.idSegnalazione === segnalazione.id)
                    && [-1, segnalazione.tipo_segnalazione_id].includes(rootState.reportFiltriSegnalazione.tipoSegnalazione)
                    && [-1, segnalazione.stato_segnalazione_id].includes(rootState.reportFiltriSegnalazione.statoSegnalazione)
                    && (!rootState.reportFiltriSegnalazione.soloDaCro || segnalazione.segnalatore_id === UTENTE_CRO)
                ))
        ),
        segnalazioniGeojson: (state: any, getters: any, rootState: any) => ({
            type: 'FeatureCollection',
            features: getters.segnalazioniFiltrate.map((segnalazione: any) => ({
                type: 'Feature',
                geometry: {
                    type: 'Point',
                    coordinates: [segnalazione.longitudine, segnalazione.latitudine]
                },
                properties: {
                    id: segnalazione.id,
                    tipo_segnalazione: segnalazione.tipo_segnalazione_id,
                    stato_segnalazione: segnalazione.stato_segnalazione_id
                }
            }))
        })
    },
    mutations: {
        CARICA_SEGNALAZIONI: (state: any, payload: any) => (state.segnalazioni = payload),
        SET_STATO_SEGNALAZIONI: (state: any, payload: any) => (state.statoSegnalazioni = payload),
        // == Segnalazione mostrata ==
        SET_SEGNALAZIONE_MOSTRATA: (state: any, segnalazione: any) => (state.segnalazioneMostrata = segnalazione),
        // il centro della mappa per aggiungere segnalazioni
        SET_CENTRO_MAPPA: (state: any, centroMappa: any) => (state.centroMappa = centroMappa)
    },
    actions: {
        async caricaSegnalazioni({commit, rootState}: any, {light}) {
            try {
                const response = await Vue.axios.get(light ? '/api_report/segnalazioni_light.json' : '/api_report/segnalazioni.json', {
                    params: {
                        ente_gestore_segnalazione_id: rootState.reportFiltriSegnalazione.enteGestore
                    }
                })
                const segnalazioni = response.data
                // carica i segnalazioni geojson
                commit('CARICA_SEGNALAZIONI', segnalazioni)
            } catch (err) {
                console.error(err)
            }
        },
        async caricaStatoSegnalazioni({commit}: any) {
            try {
                const response = await Vue.axios.get('/report/stato_segnalazioni.json')
                commit('SET_STATO_SEGNALAZIONI', response.data)
            } catch (err) {
                console.error(err)
            }
        },
        async cambiaSegnalazioneMostrata({commit, rootState}: any, id: number) {
            // toglie il precedente
            commit('SET_SEGNALAZIONE_MOSTRATA', null)
            // troviamo il rilevamento
            try {
                const response = await Vue.axios.get(`/api_report/segnalazioni.json?id=${id}`)
                const rilevamento = response.data[0]
                commit('SET_SEGNALAZIONE_MOSTRATA', rilevamento)
            } catch (err) {
                console.error(err)
            }
        }
    }
}
